import * as authApi from '#lib/authApi'
import { getToken, setToken } from '#lib/tokenStore'

const DEV_AUTH_BYPASS = import.meta.env.DEV && import.meta.env.REACT_APP_DEV_AUTH_BYPASS === 'true'

let sessionPromise: Promise<string | null> | null = null

async function bootstrapSession(): Promise<string | null> {
  try {
    const response = await authApi.refresh()
    setToken(response.token)
    return response.token
  } catch {
    return null
  }
}

/**
 * Once-per-document silent refresh. Seeds the in-memory token on success and
 * resolves to null on failure without throwing. Mid-session 401 retries stay
 * on `refreshTokenWithLock` in the API client.
 */
export function ensureSession(): Promise<string | null> {
  if (DEV_AUTH_BYPASS) return Promise.resolve(getToken())

  const existing = getToken()
  if (existing) return Promise.resolve(existing)

  if (!sessionPromise) sessionPromise = bootstrapSession()

  return sessionPromise.then((): string | null => getToken())
}

export function resetSessionForTests(): void {
  sessionPromise = null
}
